export const excludeProducts = [
  "mtg single",
  "binderpos Event",
  "event ticket",
  "pokemon single",
  "yugioh single",
  "dragon ball super single",
  "flesh and blood single",
];
